/**
 * Practitioners Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";
// States
const state = {
    practitioners: [],
    practitioner: {}
};

// Getters
const getters = {
    practitioners: state => {
        return state.practitioners
    },

    practitioner: state => {
        return state.practitioner
    }
};

// Actions
const actions = {
    getPractitioners(context, payload) {
        function successCallback(response) {
            context.commit('getPractitionersHandler', { practitioners: response.data.praticiens });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Practitioner.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPractitioner(context, payload) {
        function successCallback(response) {
            context.commit('getPractitionerHandler', { practitioner: response.data.praticien });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Practitioner.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPractitioner(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'practitioner', params: { practitioner: response.data.praticien.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Practitioner.Create, localToken, successCallback, errorCallback, payload.errorMessages);
        let url = AppConfig.apiUrl + apiModel.Practitioner.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        },

    updatePractitioner(context, payload) {
        function successCallback(response) {
            if (response.data.hasOwnProperty('message')){
                Vue.swal(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            else{
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }
            store.dispatch('findAndRemove', {name: 'practitioner' });
            router.push({ name: 'practitioner', params: { practitioner: response.data.praticien.slug } });

        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Practitioner.Update, localToken, successCallback, errorCallback, payload.errorMessages);

        let url = AppConfig.apiUrl + apiModel.Practitioner.Create.url + '/' + payload.practitioner;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    deletePractitioner(context, payload) {
        function successCallback(response) {
            context.commit('deletePractitionerHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Practitioner.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getPractitionersHandler(state, { practitioners }) {
        // Update practitioners state
        state.practitioners = practitioners;
    },

    getPractitionerHandler(state, { practitioner }) {
        // Update practitioner state
        state.practitioner = practitioner;
    },

    deletePractitionerHandler(state, { index, successMessage }) {
        let i = state.practitioners.findIndex(practitioner => practitioner.slug === index);

        if (~i) {
            state.practitioners.splice(i, 1);

            router.push({ name: 'practitioners' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}